// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__OasU2","title":"Images90_title__pqtda","images":"Images90_images__1o7Z3"};